(() => {
  const LOW_STOCK_RE = /^Only\s+\d+\s+items?\s+left\s+in\s+stock!?$/i;
  const ROOT_SELECTOR = '.product-form__buttons, product-form, .product__info-container';

  const elementText = (element) => element.textContent.replace(/\s+/g, ' ').trim();

  const removableLowStockElement = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.matches('script, style, template, product-form, form, button, shopify-payment-terms')) return false;
    if (!LOW_STOCK_RE.test(elementText(element))) return false;
    return !element.querySelector('button, input, select, textarea, a, shopify-payment-terms');
  };

  const removeLowStockMessages = (root = document) => {
    root.querySelectorAll('.scw-product-stock-note').forEach((element) => element.remove());

    root.querySelectorAll(ROOT_SELECTOR).forEach((container) => {
      Array.from(container.querySelectorAll('*')).forEach((element) => {
        if (removableLowStockElement(element)) element.remove();
      });
    });
  };

  const disableReStockLowStock = () => {
    const config = window._ReStockConfig?._metafields?.sdkConfig?.low_stock?.product_page;
    if (!config) return;
    config.is_elements_shown = false;
  };

  const scheduleCleanup = () => {
    disableReStockLowStock();
    removeLowStockMessages();
    window.setTimeout(removeLowStockMessages, 250);
    window.setTimeout(() => {
      disableReStockLowStock();
      removeLowStockMessages();
    }, 1000);
  };

  let cleanupQueued = false;
  const queueCleanup = () => {
    if (cleanupQueued) return;
    cleanupQueued = true;
    window.requestAnimationFrame(() => {
      cleanupQueued = false;
      disableReStockLowStock();
      removeLowStockMessages();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanup);
  } else {
    scheduleCleanup();
  }

  const observer = new MutationObserver(queueCleanup);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  window.setTimeout(() => observer.disconnect(), 4000);
})();
